import MainLayout from '@/pages/Layout/MainLayout.vue'
const AdvocatApps = () => import('@/pages/specialist/advocat/AdvocatApps.vue')
const AdvocatApp = () => import('@/pages/specialist/advocat/AdvocatApp.vue')
const SpecialistApps = () => import('@/pages/specialist/AppList.vue')
const SpecialistApp = () => import('@/pages/specialist/AppView.vue')
const SpecialistReestr = () => import('@/pages/specialist/AppReestr.vue')
const GroupManage = () => import('@/pages/specialist/GroupList.vue')
const SpecialistManage = () => import('@/pages/specialist/SpecialistList.vue')
const SpecialistRegister = () => import('@/pages/specialist/SpecialistRegister.vue')


export default {
  path: '/specialist',
  redirect: '/specialist/apps',
  component: MainLayout,
  children: [
    {
      path: 'apps',
      name: 'SpecialistApps',
      component: SpecialistApps,
      meta: {
        title: 'Заявки на оплату',  
      }
    },
    {
      path: 'apps/:appId',
      name: 'AppDetail',
      component: SpecialistApp,
      props: true,
      meta: {
        title: 'Заявка на оплату',  
      }
    },
    {
      path: 'group',
      name: 'GroupManage',
      component: GroupManage,
      meta: {
        title: 'Управление группами',  
      }
    },
    {
      path: 'list',
      name: 'SpecialistManage',
      component: SpecialistManage,
      meta: {
        title: 'Модерация специалистов',  
      }
    },
    {
      path: 'profile',
      name: 'SpecialistProfile',
      component: SpecialistRegister,
      meta: {
        title: 'Профиль специалиста',
      }
    },
    {
      path: 'profile/:specId',
      name: 'SpecialistEditProfile',
      component: SpecialistRegister,
      props: true,
      meta: {
        title: 'Профиль специалиста',
      }
    },
    {
      path: 'reestr',
      name: 'SpecialistReestr',
      component: SpecialistReestr,
      meta: {
        title: 'Счета на оплату',  
      }
    },
    {
      path: 'advocat/apps',
      name: 'AdvocatApps',
      component: AdvocatApps,
      meta: {
        title: 'Мои заявки',  
      }
    },
    {
      path: 'advocat/apps/:appId',
      name: 'AdvocatAppDetail',
      component: AdvocatApp,
      props: true,
      meta: {
        title: 'Мои заявки',  
      }
    }
  ]
}
